import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Switch,
} from 'antd';
import { useMutation, useQueryClient } from 'react-query';

import { updateParameter } from '../../../../services/dataset.service';
import MapQueryTypes from '../../../../services/query-types/map';
import ConfirmationModal from '../ConfirmationModal';

const ShowParameterToggle = (props) => {
  const { parameter } = props;

  const queryClient = useQueryClient();

  const [checked, setChecked] = useState(!parameter?.hide_in_ui);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const parameterMutation = useMutation(
    (payload) => updateParameter(parameter?.parameter_id, payload),
    {
      onSettled: () => {
        queryClient.invalidateQueries(MapQueryTypes.REST_PARAMETERS_REGISTERED_DASHBOARD);
        queryClient.invalidateQueries(MapQueryTypes.REST_PARAMETERS_REGISTERED_PARAMETERDETAIL);
        queryClient.invalidateQueries(MapQueryTypes.REST_PARAMETERS_REGISTERED_DATACONSOLE);
        queryClient.invalidateQueries(MapQueryTypes.REST_PARAMETERS_REGISTERED_PARAMETERDETAIL);
        // TODO: use the same cache key for parameters everywhere since it's hitting the same endpoint
      },
    },
  );

  const onChange = (checkedValue) => {
    setChecked(checkedValue);

    if (!checkedValue) {
      // If we are hiding the parameter, show the modal to confirm
      setIsModalOpen(true);
    }

    if (checkedValue) {
      const payload = {
        hide_in_ui: false,
      };

      parameterMutation.mutate(payload);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);

    const payload = {
      hide_in_ui: !checked,
    };

    parameterMutation.mutate(payload);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setChecked(!checked);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
      }}
    >
      <span
        style={{
          fontWeight: 400,
          fontSize: 13,
        }}
      >
        Public
      </span>
      <Switch
        checked={checked}
        onChange={onChange}
        size="small"
      />
      <ConfirmationModal
        handleCancel={handleCancel}
        handleOk={handleOk}
        title="Are you sure you want to hide this parameter?"
        content="This parameter will no longer be publicly visible on Seagull."
        visible={isModalOpen}
      />
    </div>
  );
};

ShowParameterToggle.propTypes = {
  parameter: PropTypes.object,
};

ShowParameterToggle.defaultProps = {
  parameter: {},
};

export default ShowParameterToggle;
